import React from 'react'

import { Skeleton } from 'primereact/skeleton'

export const LoadingDocumentPreviewCard: React.FC = () => {
  return (
    // Card
    <div className="border-round-2xl border-1 border-100 bg-white p-3 flex align-items-center gap-3">
      {/* Content container*/}
      <div className="flex flex-column gap-1">
        {/* Category */}
        <Skeleton height="14px" width="100px" />

        {/* Filename */}
        <Skeleton height="19px" width="200px" />

        {/* Size and Type */}
        <div className="flex align-items-center gap-2 text-xs text-400">
          <Skeleton height="14px" width="75px" />
        </div>

        {/* Download button */}
        <Skeleton height="37px" width="37px" />
      </div>
    </div>
  )
}
